import { useEffect, useRef } from 'react';
import GolfoNavbar from './components/GolfoNavbar';
import GolfoHero from './components/GolfoHero';
import AvailabilitySearchBar from '@/components/feature/AvailabilitySearchBar';
import GolfoAmenities from './components/GolfoAmenities';
import GolfoDescription from './components/GolfoDescription';
import GolfoGallery from './components/GolfoGallery';
import GolfoFeatures from './components/GolfoFeatures';
import GolfoLayout from './components/GolfoLayout';
import GolfoMap from './components/GolfoMap';
import GolfoRules from './components/GolfoRules';
import GolfoCTA from './components/GolfoCTA';
import Footer from '@/pages/home/components/Footer';
import VillaBookingSection from '@/components/feature/VillaBookingSection';

export default function CasaDeElGolfo() {
  const observerRef = useRef<IntersectionObserver | null>(null);

  useEffect(() => {
    observerRef.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );

    const elements = document.querySelectorAll('.scroll-reveal');
    elements.forEach((el) => observerRef.current?.observe(el));

    return () => {
      observerRef.current?.disconnect();
    };
  }, []);

  return (
    <main>
      <GolfoNavbar />
      <GolfoHero />
      <AvailabilitySearchBar villaSlug="casa-de-el-golfo" />
      <VillaBookingSection villaSlug="casa-de-el-golfo" />
      <GolfoAmenities />
      <GolfoDescription />
      <GolfoGallery />
      <GolfoFeatures />
      <GolfoLayout />
      <GolfoMap />
      <GolfoRules />
      <GolfoCTA />
      <Footer />
    </main>
  );
}